export enum ValidationResultMessage {
	NOT_FOUND = 'No se ha encontrado el celular cargado',
	EXPIRATED_LINK = 'Se termino el tiempo para validar el codigo',
	PREVIOUSLY_VALIDATED = 'Ya se ha validado antes',
	OK = 'Se valido correctamente',
	FAILED = 'El codigo no es el correcto',
}
